/**
 * Shared discount-aware price calculation.
 *
 * `clientPriceNet` is the pre-discount net price; `discountPercent` is applied
 * on top of it. This is the single source of truth for that formula, used by
 * both apps/web (client-facing price display) and apps/api (Decyzje klienta
 * offered price) so the same version never shows two different prices for the
 * same unit (CU-86cb4wjwj). The equivalent SQL form lives separately in
 * packages/db/src/queries/offer-versions/list-versions-by-offer.ts, which
 * cannot import this TS function.
 */
export function computeDiscountedPrice(
  clientPriceNet: number,
  discountPercent: number | null | undefined,
): number {
  const discount = discountPercent ?? 0;
  return clientPriceNet * (1 - discount / 100);
}
